exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1Be7t8o83Dr5Z7OyrHoPxo{width:100%}\n", ""]);

// Exports
exports.locals = {
	"SampleGraph": "_1Be7t8o83Dr5Z7OyrHoPxo"
};